module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/userPrivacy-more.0b2e2f9b.png";